module.exports = __webpack_public_path__ + "static/media/20200831_163336.86c48eb2.jpg";